/**
 * "Connect a store" control.
 *
 * WHY a full-page navigation instead of fetch: the API's install route needs the browser to
 * carry the pa_session cookie into the Shopify OAuth round trip — that cookie is what attaches
 * the new shop to this seller's tenant. An XHR would authorise the shop into nobody's account.
 */
import { useState, type ReactNode } from "react";
import { isValidShopDomain, normalizeShopDomain, shopifyInstallUrl } from "../api";

export function ConnectStore(): ReactNode {
  const [value, setValue] = useState("");
  const domain = normalizeShopDomain(value);
  const ready = isValidShopDomain(domain);

  return (
    <form
      className="connect"
      onSubmit={(e) => {
        e.preventDefault();
        if (ready) window.location.assign(shopifyInstallUrl(domain));
      }}
    >
      <label className="field">
        <span className="field-label">Connect a Shopify store</span>
        <input
          className="input"
          type="text"
          name="shop"
          autoComplete="off"
          spellCheck={false}
          placeholder="your-store.myshopify.com"
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
      </label>
      <button type="submit" className="btn btn-primary" disabled={!ready}>Connect</button>
      <p className="hint">{value && !ready ? `"${domain}" is not a valid myshopify.com domain.` : "You will be sent to Shopify to approve read-only access."}</p>
    </form>
  );
}
